import { useEffect } from 'react';

export const usePaymentMessageListener = (
  onPaymentFinished: () => void,
  onPaymentFailed?: () => void
): void => {
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data === 'paymentFinished' && onPaymentFinished) {
        onPaymentFinished();
      }

      if (
        (event.data === 'paymentFailed' || event.data === 'paymentFailure') &&
        onPaymentFailed
      ) {
        onPaymentFailed();
      }
    };

    window.addEventListener('message', handleMessage, true);
    return () => window.removeEventListener('message', handleMessage, true);
  }, [onPaymentFinished, onPaymentFailed]);
};
